import React from "react";
import { HERO_BG, PageHero } from "../shared";

const GivePage = () => {
  return (
    <div className="pt-20 fade-in">
      <PageHero eyebrow="Generosity" title="Give" italic bg={HERO_BG.give} testId="give-title" />
      <section className="py-32 bg-white">
        <div className="max-w-2xl mx-auto px-8 text-center">
          <p className="heading-caps text-xs text-black/40 mb-6 tracking-[0.3em]">2 Corinthians 9:7</p>
          <p className="text-xl md:text-2xl text-black/70 leading-relaxed mb-12 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            &ldquo;Each one must give as he has decided in his heart, not reluctantly or under compulsion, for God loves a cheerful giver.&rdquo;
          </p>
          <p className="text-black/60 leading-relaxed mb-12 max-w-lg mx-auto">
            Your generosity fuels the mission — reaching Lancaster, sending missionaries to Tijuana and Brazil,
            and equipping the next generation of disciples and leaders.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-14" data-testid="fund-categories">
            {[{ id: "tithe", label: "Tithes" }, { id: "offering", label: "Offering" }, { id: "missions", label: "Missions" }, { id: "building", label: "Building" }].map((fund) => (
              <div key={fund.id} className="p-4 text-center text-xs uppercase tracking-[0.2em] bg-neutral-50 border border-black/5 text-black/60" data-testid={`fund-${fund.id}`}>
                {fund.label}
              </div>
            ))}
          </div>
          <p className="text-xs text-black/40 mb-12 -mt-10">Select your fund on the next screen</p>
          <a href="https://give.tithe.ly/?formId=c68fa17a-6865-11ee-90fc-1260ab546d11"
            target="_blank" rel="noopener noreferrer" className="whco-give-btn" data-testid="tithely-give-btn"
          >Give Now</a>
          <p className="mt-8 text-xs text-black/40 tracking-widest uppercase">Secured by Tithely</p>
        </div>
      </section>
    </div>
  );
};

export default GivePage;
